
import { Component, OnInit, Inject, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'src/app/shared/Notification.service';

import { ThanhVien } from 'src/app/shared/ThanhVien.model';
import { ThanhVienService } from 'src/app/shared/ThanhVien.service';
import { AppComponent } from 'src/app/app.component';
import { ConfirmOtpComponent } from '../confirm-otp/confirm-otp.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  private bodyClickListener?: () => void;
  MatKhauIsActive: boolean = true;
  constructor(
    private dialog: MatDialog,
    private renderer: Renderer2,
    public router: Router,
    public NotificationService: NotificationService,
    public ThanhVienService: ThanhVienService,
    public AppComponent: AppComponent,
  ) { }

  ngOnInit(): void {
    this.ThanhVienService.GetLogin();
    this.GetByQueryString();
    document.getElementById("sidebar").style.display = "none";
    //document.getElementById("main-container").style.padding = "0";
    this.BodyListener();
    this.showMailConfirm = false;
  }
  
  BodyListener() {
    let isProcessing = false;
    this.bodyClickListener = this.renderer.listen(
      document.body,
      'keyup',
      (event) => {
        if (event && event.keyCode === 13 && !isProcessing) {
          isProcessing = true;
          this.Submit();
          // Reset sau 500ms để tránh double submit
          setTimeout(() => {
            isProcessing = false;
          }, 500);
        }
      }
    );
  }
  
  ngOnDestroy(): void {
    document.getElementById("sidebar").style.display = "block";
    //document.getElementById("main-container").style.padding = "0 0 0 300px";
    if (this.bodyClickListener) {
      this.bodyClickListener();
    }
  }

  MatKhauChangeType() {
    this.MatKhauIsActive = !this.MatKhauIsActive;
  }

  GetByQueryString() {
    this.ThanhVienService.BaseParameter.ID = this.ThanhVienService.FormDataLogin.ID;
    if(this.ThanhVienService.BaseParameter.ID == environment.InitializationNumber){
      return;
    }
    this.ThanhVienService.IsShowLoading = true;
    this.ThanhVienService.GetByIDAsync().subscribe(
      res => {
        this.ThanhVienService.FormDataLogin = res as ThanhVien;
        this.router.navigate(['/' + environment.Homepage]);
        this.ThanhVienService.IsShowLoading = false;
      },
      err => {
        this.ThanhVienService.IsShowLoading = false;
      }
    );
  }
  showMailConfirm = false;
  Submit() {
    console.log('[Login] Submit called. Username:', this.ThanhVienService.FormData.TaiKhoan);
    this.ThanhVienService.IsShowLoading = true;
    let tokenFCM = localStorage.getItem(environment.TokenFCM);
    if (tokenFCM != null) {
      this.ThanhVienService.FormData.uid = tokenFCM;
    }
    this.ThanhVienService.AuthenticationAsync().subscribe(
      res => {
        console.log('[Login] API response:', res);
        this.ThanhVienService.IsShowLoading = false;
        this.ThanhVienService.FormDataLogin = res as ThanhVien;
        if (this.ThanhVienService.FormDataLogin) {
          if (this.ThanhVienService.FormDataLogin.HTMLContent) {
            if(this.ThanhVienService.FormDataLogin.Active!=true){
              this.NotificationService.warn(environment.LoginNotActive);
              return;
            }
            if(this.ThanhVienService.FormDataLogin.IsMailConfirm){
              localStorage.setItem(environment.Token, this.ThanhVienService.FormDataLogin.HTMLContent);
              localStorage.setItem(environment.ThanhVienID, this.ThanhVienService.FormDataLogin.ID.toString());
              localStorage.setItem(environment.ThanhVienParentID, this.ThanhVienService.FormDataLogin.ParentID?.toString());
              localStorage.setItem(environment.ThanhVienTaiKhoan, this.ThanhVienService.FormDataLogin.TaiKhoan);
              localStorage.setItem(environment.ThanhVienHoTen, this.ThanhVienService.FormDataLogin.Name);
              localStorage.setItem(environment.ThanhVienFileName, this.ThanhVienService.FormDataLogin.FileName);
              localStorage.setItem(environment.ThanhVienStateAgencyID, this.ThanhVienService.FormDataLogin.StateAgencyID?.toString());
              if (this.ThanhVienService.FormDataLogin.CompanyInfoID) {
                localStorage.setItem(environment.ThanhVienCompanyInfoID, this.ThanhVienService.FormDataLogin.CompanyInfoID?.toString());
              }
              else {
                localStorage.setItem(environment.ThanhVienCompanyInfoID, environment.InitializationNumber.toString());
              }
              this.router.navigate(['/' + environment.Homepage]);
            
            }else{
              this.openOtpDialog();
            }
          }
          else {
            console.warn('[Login] HTMLContent is empty. LoginNotSuccess.');
            this.NotificationService.success(environment.LoginNotSuccess);
          }
        } else {
          console.warn('[Login] FormDataLogin is null/undefined. Raw response:', res);
          this.NotificationService.warn(environment.LoginNotSuccess);
        }
      },
      err => {
        console.error('[Login] AuthenticationAsync error:', err);
        console.error('[Login] Error status:', err?.status);
        console.error('[Login] Error statusText:', err?.statusText);
        console.error('[Login] Error message:', err?.message);
        console.error('[Login] Error url:', err?.url);
        console.error('[Login] Full error object:', JSON.stringify(err, null, 2));
        let message = environment.LoginNotSuccess;
        if (err && err.error) {
          if (typeof err.error === 'string') {
            message = err.error;
          } else if (err.error.message) {
            message = err.error.message;
          }
        }
        // Hiển thị lỗi chi tiết hơn
        if (err?.status === 0) {
          message = 'Không thể kết nối đến server. Vui lòng kiểm tra kết nối mạng.';
        } else if (err?.status === 404) {
          message = 'API endpoint không tìm thấy. URL: ' + (err?.url || 'unknown');
        } else if (err?.status >= 500) {
          message = 'Lỗi server: ' + (err?.statusText || 'Unknown error');
        }
        this.NotificationService.warn(message);
        this.ThanhVienService.IsShowLoading = false;
      }
    );
  }
  openOtpDialog() {
    this.ThanhVienService.FormData.TaiKhoan = this.ThanhVienService.FormDataLogin.TaiKhoan;
    this.ThanhVienService.SendOTPAsync().subscribe(
      res => {
      },
      err => {
      }
    );
    const dialogRef = this.dialog.open(ConfirmOtpComponent, {
      width: '475px',
      disableClose: true
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        // OTP đã được xác nhận thành công
        console.log('OTP verified successfully');
      } else {
        // Người dùng đã hủy
        console.log('OTP verification cancelled');
      }
    });
  }
}
